import React  from 'react';

type Props = {
    name?       : string
    description?: string
    onBackClick?: any
}

export default function NewTitle(props: Props) {

    const description = !!props.description ?
        <div className="flex-row-left-center ui5-txt-less-important lh-14em m-t-10">
            {props.description}
        </div>
        :
        null

    if (props.onBackClick) {
        return (
            <div className="new-form-title">
                <div className="flex-row-left-center ui5-title-app-name p-l-35" onClick={props.onBackClick}>
                    <div className="i5-long-arrow-left back-icon"/>
                    {props.name}
                </div>
                {description}
            </div>
        )
    } else {
        return (
            <div className="new-form-title">
                <div className="flex-row-left-center ui5-title-app-name p-l-35">
                    {props.name}
                </div>
                {description}
            </div>
        )
    }

}